module.exports = __webpack_public_path__ + "img/calculation.f1223116.png";